import moment from "moment";
import { PERIOD_FORMAT } from "../../services/enterprises/crews/enterpriseCrewPayrollService";
import authService from "@/services/authService";
import { ColorMixin } from "@/mixins";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
const { AISEA_COLOR } = ColorMixin.data();

// 通知するエラーの種類
export const ERRORS = {
  INVALID_PERIOD: "INVALID_PERIOD",
  CONFLICT: "CONFLICT",
  SYSTEM_ERROR: "SYSTEM_ERROR",
};
const ERROR_MESSAGES = {
  INVALID_PERIOD: "期間は31日以内で指定してください",
  CONFLICT: "未承認の打刻があります",
  SYSTEM_ERROR:
    "予期しないエラーが発生しました。時間を空けてもう一度試みてください",
};

export const loadingStart = (
  vc //  VueComponent
) => {
  vc.$vs.loading({ color: AISEA_COLOR.BLUE });
};

export const loadingClose = (
  vc //  VueComponent
) => {
  vc.$vs.loading.close();
};

// システムエラー通知
export const notifySystemError = (
  vc, //  VueComponent
  options = {
    fixed: false,
    color: "danger",
    iconPack: "feather",
    icon: "icon-x-square",
    position: "bottom-right",
    title: "システムエラー",
    text: ERROR_MESSAGES["SYSTEM_ERROR"],
  }
) => {
  vc.$vs.notify({
    ...options,
  });
};

// 期間が不正な場合の通知
export const notifyInvalidPeriodError = (
  vc, //  VueComponent
  options = {
    fixed: false,
    color: "danger",
    position: "bottom-right",
    title: ERROR_MESSAGES["INVALID_PERIOD"],
  }
) => {
  vc.$vs.notify({
    ...options,
  });
};

// 409エラー通知
export const notifyConflictError = (
  vc, //  VueComponent
  options = {
    fixed: false,
    color: "danger",
    position: "bottom-right",
    title: ERROR_MESSAGES["CONFLICT"],
  }
) => {
  vc.$vs.notify({
    ...options,
  });
};

// ダイアログに表示するエラーメッセージのリストを作成
export const createErrorMessages = (
  errors = [], // keyof typeof ERROR_MESSAGES[]; like ["INVALID_PERIOD"]
  errorMessageMap = ERROR_MESSAGES
) => {
  const errorMessages = errors
    .filter(error => errorMessageMap[error])
    .map(error => {
      return {
        key: error,
        message: errorMessageMap[error],
      };
    });
  return errorMessages; // [{key: keyof typeof ERROR_MESSAGES; message: string;}]
};

// Date オブジェクトを指定フォーマットに変換
const applyFormatToPeriod = (
  date, // Date
  format = PERIOD_FORMAT
) => {
  const applied = moment(date).format(format);
  return applied;
};

// 給与システム連携のファイル名を生成
// e.g. 給与システム連携_YYYY-MM-DD_YYYY-MM-DD.csv
export const createPayrollFileName = (
  startDate, // Date
  endDate // Date
) => {
  const prefix = "給与システム連携";
  const extension = "csv";
  const start = applyFormatToPeriod(startDate);
  const end = applyFormatToPeriod(endDate);
  const fileName = `${prefix}_${start}_${end}.${extension}`;
  return fileName;
};

// 分析用データのファイル名を生成
// e.g. 分析用データ_${船舶名}_YYYY-MM-DD_YYYY-MM-DD.xlsx
export const createAnalysisFileName = (
  startDate, // Date
  endDate, // Date
  vesselName // string
) => {
  const prefix = `分析用データ_${vesselName}`;
  const extension = "xlsx";
  const start = applyFormatToPeriod(startDate);
  const end = applyFormatToPeriod(endDate);
  const fileName = `${prefix}_${start}_${end}.${extension}`;
  return fileName;
};

// データ出力で使用する船舶情報のドロップダウンのアイテムとして使用可能かチェック
export const isValidVesselDropdown = (
  vessel // {id: `${number}`; name: string;}
) => {
  if (!isObject(vessel)) return false;
  const hasId = /^\d+$/.test(vessel.id);
  const hasName = isString(vessel.name);
  return hasId && hasName; // boolean
};

// データ出力で使用するダイアログのプロパティを生成
export const createBaseDialogProps = payload => {
  if (!isObject(payload)) {
    return {};
  }
  const {
    title,
    type,
    color,
    acceptText,
    cancelText,
    active,
    confirmText,
    isDownloadEnable = false,
    errorMessages = [],
  } = payload;
  const props = {
    title,
    type,
    color,
    acceptText,
    cancelText,
    active,
    confirmText,
    isDownloadEnable,
    errorMessages,
  };
  return props;
};

// CREW_PAYROLL アドオンを保有しているかチェック
export const hasCrewPayroll = (
  addonMap //  { [id]: addon }
) => {
  const { CREW_PAYROLL } = authService.ADDON_IDS;
  const hasCrewPayroll = addonMap[CREW_PAYROLL];
  return !!hasCrewPayroll; // boolean
};
